<template>
    <b-modal :active.sync="show" id="ContractsRecordConfirmStopModal" aria-modal :width="600" :can-cancel="false">
        <div class="modal-card" style="width: auto">
            <b-loading :active.sync="loading" :is-full-page="false"></b-loading>

            <header class="modal-card-head"><p class="modal-card-title">{{ type == 'stop' ? 'Contract stoppen' : 'Contract verlengen' }}</p></header>
            <section class="modal-card-body" style="overflow: hidden;border-radius:0;">
                Weet je zeker dat {{ type == 'stop' ? 'je het contract wilt stoppen?' : 'je het contract wil verlengen?' }}
            </section>
            <footer class="modal-card-foot text-right">
                <button class="button" type="button" @click="$emit('closeConfirmStopModal')" :loading="loading">Annuleren</button>
                <button class="button is-success" @click="confirm" :loading="loading">Bevestigen</button>
            </footer>
        </div>
    </b-modal>
</template>

<script>
import toastMixins from '@/mixins/toastMixins.js'

export default {
    name: 'ContractsRecordConfirmStopModal',

    mixins: [toastMixins],

    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        },
        record: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            loading: false
        }
    },

    methods: {
        confirm() {
            this.loading = true
            console.log(this.type)

            axios.post(`/api/contract/${this.$route.params.id}/stop-or-extend/${this.type}`, {}, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                if(response.data == 'contractstopped'){
                    this.showMessage('Contract is succesvol gestopt.')
                }
                if(response.data == 'contractwillstop'){
                    this.showMessage('Contract zal aflopen op de normale einddatum.')
                }
                if(response.data == 'extended'){
                    this.showMessage('Contract is succesvol verlengt en een nieuwe factuur wordt aangemaakt.')
                }

                this.loading = false
                this.$router.push({name: 'ContractsOverview'})

            }).catch((e) => {
                console.log(e)
                this.showError('Daar gaat iets fout! Probeer het opnieuw.')
            })
        }


        // endContract(){
        //     this.loading = true

        //     axios.post('/api/contract/'+this.$route.params.id+'/end-contract',
        //     {
        //         perDirect: this.perDirect,
        //         endDate: this.endDate,
        //         cancelInvoices: this.cancelInvoices,
        //         cancelAllInvoices: this.cancelAllInvoices,
        //     }, {
        //         headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
        //     }).then((response) => {
        //         if(response.data == 'success'){
        //             this.showMessage(this.perDirect ? 'Contract per direct beëindigd!' : 'Contract einddatum aangepast!')

        //             if (this.hasAccess !== false) {
        //                 this.showAccessMessage = true
        //             } else {
        //                 this.$emit('closeEndContractModal')
        //             }

        //             this.$emit('reload')
        //         } else {
        //             throw error(response.data)
        //         }
        //     }).catch((error) => {
        //         if(_.has(error, 'response.data.error') && error.response.data.error == 'not-org-admin'){
        //             this.showError('Opslaan niet mogelijk, enkel een administrator is gemachtigd om deze gegevens aan te passen.')
        //         } else {
        //             this.showError('Daar gaat iets fout! Probeer het opnieuw!')
        //         }

        //         this.$emit('closeEndContractModal')
        //     }).then(() => {
        //         this.loading = false
        //     })
        // }
    }
}
</script>